/*!

=========================================================
* Black Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import classnames from "classnames";
import NotificationAlert from "react-notification-alert";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
} from "reactstrap";

import { UserLoginContext } from "../../context/UserLoginContext";
import { login } from "../../services/authService";

const Login = () => {
  const [state, setState] = React.useState({
    email: "",
    password: "",
    emailFocus: false,
    passFocus: false,
    showPassword: false,
    loading: false,
    error: ""
  });
  const [, setUserState] = useContext(UserLoginContext);
  const history = useHistory();
  const notificationAlertRef = React.useRef(null);
  const emailInputRef = React.useRef(null);

  React.useEffect(() => {
    document.body.classList.toggle("login-page");
    return function cleanup() {
      document.body.classList.toggle("login-page");
    };
  }, []);

  const notify = (type, message, duration = 7) => {
    const options = {
      place: "tc",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: duration,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!state.email || !state.password) {
      notify("danger", "Please enter both email and password", 3);
      setTimeout(() => {
        emailInputRef.current?.focus();
      }, 100);
      return;
    }

    setState({ ...state, loading: true, error: "" });

    try {
      const result = await login(state.email, state.password);

      if (result.success) {
        // Update UserLoginContext with user data
        setUserState({
          Userid: result.user.email,
          Email: result.user.email,
          Fname: result.user.firstName || "",
          Lname: result.user.lastName || "",
          status: true,
          role: result.user.role,
          _id: result.user._id,
          token: result.token,
          cloudinary_upload: result.user.cloudinary_upload || "",
          cloudinary_destory: result.user.cloudinary_destory || "",
          apiKeyCloudinary: result.user.apiKeyCloudinary || "",
          apiSecretKeyCloudinary: result.user.apiSecretKeyCloudinary || "",
          apiKey: result.user.apiKey || ""
        });

        notify("success", "Login successful! Redirecting...");

        // Redirect to dashboard after a short delay
        setTimeout(() => {
          history.push("/admin/dashboard");
        }, 1000);
      } else {
        setState({ ...state, loading: false, error: result.error });
        notify("danger", result.error || "Login failed", 3);
        setTimeout(() => {
          emailInputRef.current?.focus();
        }, 100);
      }
    } catch (error) {
      setState({ ...state, loading: false, error: error.message });
      notify("danger", "An unexpected error occurred", 3);
      setTimeout(() => {
        emailInputRef.current?.focus();
      }, 100);
    }
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <div className="content">
        <Container>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form" onSubmit={handleSubmit}>
              <Card className="card-login card-white">
                <CardHeader>
                  <img
                    alt="..."
                    src={require("assets/img/card-primary.png").default}
                  />
                  <CardTitle tag="h1">Log in</CardTitle>
                </CardHeader>
                <CardBody>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.emailFocus,
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="tim-icons icon-email-85" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      innerRef={emailInputRef}
                      placeholder="Email"
                      type="email"
                      value={state.email}
                      onChange={(e) => setState({ ...state, email: e.target.value })}
                      onFocus={(e) => setState({ ...state, emailFocus: true })}
                      onBlur={(e) => setState({ ...state, emailFocus: false })}
                      disabled={state.loading}
                    />
                  </InputGroup>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.passFocus,
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="tim-icons icon-lock-circle" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password"
                      type={state.showPassword ? "text" : "password"}
                      value={state.password}
                      onChange={(e) => setState({ ...state, password: e.target.value })}
                      onFocus={(e) => setState({ ...state, passFocus: true })}
                      onBlur={(e) => setState({ ...state, passFocus: false })}
                      disabled={state.loading}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText
                        style={{ cursor: 'pointer' }}
                        onClick={() => setState({ ...state, showPassword: !state.showPassword })}
                      >
                        <i className={state.showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </CardBody>
                <CardFooter>
                  <Button
                    block
                    className="mb-3"
                    color="primary"
                    type="submit"
                    size="lg"
                    disabled={state.loading}
                  >
                    {state.loading ? "Logging in..." : "Log In"}
                  </Button>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default Login;
